import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import { benefitTypeBySlug } from './benefitTypes';
import { SubPageHeader } from '@/components/shared/SubPageHeader/SubPageHeader';

const importRoutes: Record<string, string> = {
  food: '/expenses/benefits/food/import',
  'health-promotion': '/expenses/benefits/health-promotion/import',
};

export function BenefitTypeExpensesPage() {
  const { benefitType } = useParams<{ benefitType?: string }>();
  const benefit = benefitTypeBySlug[benefitType ?? ''];

  if (!benefit) {
    return <Navigate to="/expenses/benefits" replace />;
  }

  const importRoute = importRoutes[benefit.slug];

  return (
    <div className="space-y-6">
      <SubPageHeader
        backTo="/expenses/benefits"
        icon={<benefit.icon className="h-5 w-5" aria-hidden />}
        badge="Benefícios"
        title={benefit.name}
        description="Estruture fluxos de conciliação, lançamentos e pagamentos específicos deste benefício."
        actions={
          importRoute ? (
            <Link
              to={importRoute}
              className="inline-flex items-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-primary-700"
            >
              Importar
              <ArrowRightIcon className="h-4 w-4" aria-hidden />
            </Link>
          ) : null
        }
      />

      <div className="rounded-lg border border-dashed border-gray-200 bg-white p-6">
        <h2 className="text-lg font-semibold text-gray-900">Área de trabalho</h2>
        <p className="mt-1 text-sm text-gray-600">
          Em breve, consolide tabelas, filtros e importações para o benefício de {benefit.name.toLowerCase()}.
        </p>
        <ul className="mt-4 space-y-2 text-sm text-gray-700">
          <li className="flex items-start gap-2">
            <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary-400" />
            Cadastre operações mensais, provisões e reembolsos.
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary-400" />
            Inclua filtros por competência, centro de custo ou colaborador.
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary-400" />
            Estruture exportações e conciliações com despesas gerais.
          </li>
        </ul>
      </div>
    </div>
  );
}
